import {observer} from "mobx-react-lite"
import React, {useEffect} from "react";
import __users from "./users.controller";
import {useParams} from "react-router-dom";
import i from "../../translations/i";
import {Titles} from "../../layouts/Titles";
import dayjs from "dayjs";
import {Button, Select, Table, Row, Col, DatePicker} from "antd";
import {BarChartOutlined, SettingOutlined} from "@ant-design/icons";
import moment from "moment";

export const PartnerStat = observer(() => {

    useEffect(() => {
        __users.getStatistic()
    }, [])

    const columns = [
        {
            title: 'Партнер',
            key: 'user_id',
            dataIndex: 'user_id',
            render: (user_id: number, record: any) => <a href={`/users/${user_id}`} target="_blank">#{user_id} - {record.partner.phone}</a>
        },
        {
            title: 'Куратор',
            key: 'partner',
            dataIndex: 'partner',
            render: (partner: any) => <a href={`/settings/managers/${partner.curator_id}`} target="_blank">#{partner.curator_id} - {__users.curators.find((e: any) => e.id === partner.curator_id)?.email ?? ''}</a>
        },
        {
            title: 'Купон создан',
            key: 'created_at',
            dataIndex: 'created_at',
            render: (date: any) => date ? dayjs(date).format("DD.MM.YYYY") : ''
        },
        {
            title: 'Купон активирован',
            key: 'updated_at',
            dataIndex: 'updated_at',
            render: (date: any, record: any) => record.active ? (date ? dayjs(date).format("DD.MM.YYYY") : '') : '-'
        },
        {
            title: 'ID купона',
            dataIndex: 'coupon_id',
            render: (e: number) => <a href={`https://panel.saleskit.biz/shop/coupons/${e}`} target="_blank">#{e} Перейти</a>
        }
    ]

    return(
        <>
            <Titles
                title="Статистика по купонам"
                breadcrumb={[
                    {title: "Статистика по купонам"},
                ]}
            />

            <Row gutter={[20, 20]}>
                <Col span={8}>
                    <label>Партнеры</label>
                    <Select
                        options={__users.partners.map((el: any) => ({
                            label: el.phone,
                            value: el.id
                        }))}
                        style={{ width: `100%` }}
                        mode="multiple"
                        onChange={(e: any) => {
                            __users.list.page = 1
                            __users.filter.partners = e
                        }}
                    />
                </Col>
                <Col span={8}>
                    <label>Кураторы</label>
                    <Select
                        options={__users.curators && __users.curators.map((el: any) => ({
                            label: el.email,
                            value: el.id
                        }))}
                        style={{ width: `100%` }}
                        mode="multiple"
                        onChange={(e: any) => {
                            __users.list.page = 1
                            __users.filter.managers = e
                        }}
                    />
                </Col>
                <Col span={8}>
                    <label>Статус купона</label>
                    <Select
                        options={[
                            { label: 'Все', value: null },
                            { label: 'Активированы', value: 1 },
                            { label: 'Не активированы', value: 0 },
                        ]}
                        style={{ width: `100%` }}
                        onChange={(e: any) => {
                            __users.list.page = 1
                            __users.filter.status = e
                        }}
                    />
                </Col>
                <Col span={8}>
                    <label>Дата создания купона</label>
                    <Row>
                        <Col span={12}>
                            <DatePicker
                                format="YYYY-MM-DD"
                                value={__users.filter.created_at_from}
                                onChange={(date: moment.Moment | null) => {
                                    __users.filter.created_at_from = date
                                }}
                                placeholder="От"
                            />
                        </Col>
                        <Col span={12}>
                            <DatePicker
                                format="YYYY-MM-DD"
                                value={__users.filter.created_at_to}
                                onChange={(date: moment.Moment | null) => {
                                    __users.filter.created_at_to = date
                                }}
                                placeholder="До"
                            />
                        </Col>
                    </Row>
                </Col>
                <Col span={8}>
                    <label>Дата активации купона</label>
                    <Row>
                        <Col span={12}>
                            <DatePicker
                                format="YYYY-MM-DD"
                                value={__users.filter.activated_at_from}
                                onChange={(date: moment.Moment | null) => {
                                    __users.filter.activated_at_from = date
                                }}
                                placeholder="От"
                            />
                        </Col>
                        <Col span={12}>
                            <DatePicker
                                format="YYYY-MM-DD"
                                value={__users.filter.activated_at_to}
                                onChange={(date: moment.Moment | null) => {
                                    __users.filter.activated_at_to = date
                                }}
                                placeholder="До"
                            />
                        </Col>
                    </Row>
                </Col>
                <Col span={8}>
                    <Button onClick={() => __users.getStatistic()}>Получить</Button>
                </Col>
            </Row>

            <br/><br/>

            <Table
                columns={columns}
                dataSource={__users.stat}
                rowKey="id"
                pagination={{
                    total: __users.list.count,
                    current: __users.list.page,
                    pageSize: __users.list.limit,
                    onChange: (page, pageSize) => {
                        __users.list.page = page
                        __users.getStatistic()
                    },
                    onShowSizeChange: (current, size) => {
                        __users.list.limit = size
                        __users.list.page = 1
                        __users.getStatistic()
                    }
                }}
            />
        </>
    )
})